import { oz } from '@weft/utils';
import { NET_SUITE_INTEGRATION_TYPES } from './net-suite-integration-types-schema';
import { NetSuiteInvoiceSchema } from './net-suite-invoice-schema';

export const NetSuiteSyncInvoicePayloadSchema = oz.object({
  integrationType: oz.literal(NET_SUITE_INTEGRATION_TYPES.UpsertInvoice),
  uid: oz.string(),
  data: NetSuiteInvoiceSchema,
});

export type NetSuiteSyncInvoicePayload = oz.TypeOf<typeof NetSuiteSyncInvoicePayloadSchema>;